import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDebouncedCallback } from 'use-debounce';
import { ButtonHelper } from '../../../NewFitAssistant/Helpers/ButtonHelper.ts';
import { IsProductPage } from '../../../FitAssistantShared/IsProductPage.js';
import { useAppState } from '../../State.tsx';

import AssistantBanner from '/Foundation/React/code/Components/AssistantBanner/AssistantBanner.tsx';

import './FitAssistantButton.less';

const FitAssistantButton = () => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);
  const [isPastLastItem, setIsPastLastItem] = useState(false);
  const [fitIcon, setFitIcon] = useState('le-icon-bike');
  const portalTarget = document.getElementById('fitAssistantHeaderPortal');
  const { fitAssistantBikesData, setShowFitAssistant, fitStatus } = useAppState();

  const translations = fitAssistantBikesData?.Translations;

  const handleScroll = useDebouncedCallback(() => {
    ButtonHelper.HandleStickyButtonOnScroll(buttonRef, setIsSticky);
    if (!IsProductPage) {
      ButtonHelper.HandleBannerVisibilityOnScroll(setIsPastLastItem);
    }
  }, 20);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    ButtonHelper.HandleStickyButtonOnScroll(buttonRef, setIsSticky);
    if (!IsProductPage) {
      ButtonHelper.HandleBannerVisibilityOnScroll(setIsPastLastItem);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const fitIconByStatus =
      fitStatus === 'confirmed' ? 'le-icon-check-circle' : fitStatus === 'nofit' ? 'le-icon-x-circle' : 'le-icon-bike';

    setFitIcon(fitIconByStatus);
  }, [fitStatus]);

  const handleButtonClick = () => {
    setShowFitAssistant(true);
  };

  const FitInformation = () => {
    return (
      <div className="header-wrapper mb-5">
        <h5 className={`heading5 mb-0`}>
          {translations?.fit}
          <span className="fit-status paragraph">
            {fitStatus === 'noselection'
              ? translations?.seeFits
              : fitStatus === 'confirmed'
                ? translations?.confirmed
                : translations?.noFit}
          </span>
        </h5>
      </div>
    );
  };

  const FitAssistantContent = () => {
    return (
      <div className="fit-assistant">
        {IsProductPage && <FitInformation />}

        {!IsProductPage ? (
          <AssistantBanner
            icon="le-icon-bike"
            text={translations?.findTheRightProductsForYourVehicle}
            ctaLabel={translations?.selectBikeModel}
            onCtaClick={handleButtonClick}
            onBannerClick={handleButtonClick}
            className="fit-assistant-banner"
          />
        ) : (
          <button className="fit-assistant-button pdp" onClick={handleButtonClick} tabIndex={0}>
            <div className="d-flex align-items-center">
              <i className={`fit-indicator ${fitStatus} me-5 ${fitIcon}`}></i>
              {
                <span className={`heading6 ${fitStatus} text-start d-flex align-items-center`}>
                  {fitStatus === 'noselection' && translations?.checkBikeCompatibility}
                  {fitStatus === 'confirmed' && translations?.fitsYourBike}
                  {fitStatus === 'nofit' && translations?.doesNotFitYourBike}
                </span>
              }
            </div>
            {!IsProductPage && (
              <div className="icon-wrapper--arrow">
                <i className="le-icon-arrow rot-180"></i>
              </div>
            )}
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      <div ref={buttonRef} />
      {portalTarget && isSticky && !IsProductPage && !isPastLastItem ? (
        <>
          {ReactDOM.createPortal(
            <div className="fit-assistant-isotope-constraint">
              <FitAssistantContent />
            </div>,
            portalTarget
          )}
          <div className="fit-assistant-spacer"></div>
        </>
      ) : !IsProductPage && isPastLastItem ? null : (
        <FitAssistantContent />
      )}
    </>
  );
};

export default FitAssistantButton;
